export default __webpack_public_path__ + "static/media/header.3b23104f.svg";